import { useContext } from 'react';
import { Table, TableRow, TableCell, TableHead, TableBody, TableFooter, TablePagination, Typography } from '@mui/material';
import { CircleLoader, DeleteIconButton } from 'components';
import { useIntl } from 'react-intl';
import Moment from 'react-moment';
import { LocalizationIds } from 'helpers/Localizations';
import { ticketInboxContext } from '../TicketInboxContext';
import CreateTicket from './CreateTicket';
import ViewEmail from './EmailViewer';


let Results = () => {
    let { formatMessage } = useIntl();

    let service = useContext(ticketInboxContext);


    return (
        <>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{formatMessage({ id: LocalizationIds.Date })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Sender })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Object })}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.emails.map((email, index) =>
                                <TableRow key={index} hover>
                                    <TableCell>
                                        <Moment date={email.date} format="ll LT" />
                                    </TableCell>
                                    <TableCell>
                                        {email.senderName}&nbsp;&middot;&nbsp;{email.senderEmail}
                                    </TableCell>
                                    <TableCell>{email.subject}</TableCell>
                                    <TableCell align="right">
                                        <ViewEmail id={email.id} />
                                        <CreateTicket id={email.id} />
                                        <DeleteIconButton onClick={() => service.deleteEmail(email.id)} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {service.emails.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Typography variant="subtitle2">{formatMessage({ id: LocalizationIds.NoDataFound })}</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={(e, page) => service.changePage(page)}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page, count }) =>
                            <>
                                <span>{formatMessage({ id: LocalizationIds.EmailFounded })}:&nbsp;{service.recordCount}&nbsp;&middot;&nbsp;</span>
                                {formatMessage(
                                    { id: LocalizationIds.PageOf },
                                    { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                                )}
                            </>
                        }
                    />
                </>
            }
        </>
    )
}

export default Results;